const optionsGrade = [
    {
        value: 'P5',
        grade: 'M1',
        label: '초등학교 5학년',
    },
    {
        value: 'P6',
        grade: 'M1',
        label: '초등학교 6학년',
    },
    {
        value: 'M1',
        grade: 'M1',
        label: '중학교 1학년',
    },
    {
        value: 'M2',
        grade: 'M2',
        label: '중학교 2학년',
    },
    {
        value: 'M3',
        grade: 'M3',
        label: '중학교 3학년',
    },
    {
        value: 'H1',
        grade: 'M3',
        label: '고등학교 1학년',
    },
    {
        value: 'H2',
        grade: 'M3',
        label: '고등학교 2학년',
    },
    {
        value: 'H3',
        grade: 'M3',
        label: '고등학교 3학년',
    },
];

export { optionsGrade };
